import PresupuestosPromedioPreciosContainer from './PresupuestosPromedioPreciosContainer';

export default PresupuestosPromedioPreciosContainer;
